<template>
    <v-container fluid class="pa-0">
        <v-row dense class="pt-0">
            <v-col cols="12" xl="2" lg="2" md="4" sm="6" xs="12" v-if="project.invited_count > 0">
                <stat-box-numerical :color="financialColor"
                                    :prefixIcon="accountingCurrencyPrefixIcon"
                                    :postfixIcon="accountingCurrencyPostfixIcon"
                                    :value="totalRevenue" hint="Revenue total"></stat-box-numerical>
            </v-col>

            <v-col cols="12" xl="2" lg="2" md="4" sm="6" xs="12" v-if="project.invited_count > 0">
                <stat-box-numerical :color="financialColor"
                                    :prefixIcon="accountingCurrencyPrefixIcon"
                                    :postfixIcon="accountingCurrencyPostfixIcon"
                                    :value="totalRewards"
                                    hint="Rewards issued total"></stat-box-numerical>
            </v-col>

            <v-col cols="12" xl="2" lg="2" md="4" sm="6" xs="12" v-if="project.invited_count > 0">
                <stat-box-numerical :color="financialColor"
                                    :prefixIcon="accountingCurrencyPrefixIcon"
                                    :postfixIcon="accountingCurrencyPostfixIcon"
                                    :value="grossRevenue" hint="Gross revenue"></stat-box-numerical>
            </v-col>

            <v-col cols="12" xl="2" lg="2" md="4" sm="6" xs="12" v-if="project.invited_count > 0">
                <stat-box-numerical :color="financialColor" :value="grossRevenueMargin" postfix="%"
                                    hint="Gross revenue margin"></stat-box-numerical>
            </v-col>

        </v-row>
    </v-container>
</template>

<script>

import StatBoxNumerical from '../../../../components/UI/StatBoxNumerical';
import {currencyMixin} from '../../../../components/mixins/currencyMixin';

export default {

    name: "StatBoxesProjectRevenue",

    mixins: [currencyMixin],

    components: {
        StatBoxNumerical
    },

    props: {
        project: {
            type: Object,
            required: true
        }
    },

    computed: {

        totalRevenue() {
            return this.convertToAccountingCurrency(
                this.project.revenue_profile * this.project.profile_count +
                this.project.revenue_quota * this.project.quota_count +
                this.project.revenue_completed * this.project.completed_count
            );
        },

        totalRewards() {
            return this.convertToAccountingCurrency(
                this.project.reward_profile * this.project.profile_count +
                this.project.reward_quota * this.project.quota_count +
                this.project.reward_completed * this.project.completed_count
            );
        },

        grossRevenue() {
            return this.totalRevenue - this.totalRewards;
        },

        grossRevenueMargin() {
            if (this.totalRevenue + this.totalRewards === 0) {
                return 0;
            }
            return Math.round((this.totalRevenue - this.totalRewards) / (this.totalRevenue) * 10000) / 100;
        },

        financialColor() {
            return this.grossRevenue > 0 ? 'green darken-2' : 'grey darken-1';
        }
    },

}
</script>
